/**
 * Edge = xyflow Edge. Represents a navigation link between two pages
 * in the sitemap. Per PLAN.md "Edges in the sitemap are first-class
 * navigation primitives (label, position in menu, visibility) but
 * don't determine URLs."
 *
 * `label` is the text shown in the rendered nav menu (defaults to
 * target page's `title` if omitted at render time). `menuPosition`
 * gives the user explicit ordering; if absent, source/target slug
 * order determines it.
 */
import * as Schema from "effect/Schema";

import { EdgeId, PageId } from "./ids.js";

export const Edge = Schema.Struct({
  id: EdgeId,
  source: PageId,
  target: PageId,
  label: Schema.optional(Schema.String),
  menuPosition: Schema.optional(Schema.Int.pipe(Schema.nonNegative())),
  hidden: Schema.optional(Schema.Boolean),
});
export type Edge = Schema.Schema.Type<typeof Edge>;
